import { render } from "./ClientProfileList.vue?vue&type=template&id=08db36f4"
import script from "./ClientProfileList.vue?vue&type=script&lang=js"
export * from "./ClientProfileList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__